import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { AssignCaseWorkerToCompanyAppointmentsRequest } from '../../../../api-service/clients';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';
import { useAuthenticatedUser } from '../../../../authentication';
import { AssignCaseworkerAppointmentDialogComponent } from './assign-caseworker-appointment-dialog-component';

export interface IAssignCaseworkerDialogProps {
  appointmentIds: string[];
}

export function AssignCaseworkerAppointmentDialog({ appointmentIds }: IAssignCaseworkerDialogProps) {
  const [userId, setUserId] = useState<string | undefined>();
  const [teamId, setTeamId] = useState<string | undefined>();
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const [isConfirmed, setIsConfirmed] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const currentUserId = useAuthenticatedUser()?.profile.id;

  const setTeamForUserId = async (id: string | undefined) => {
    if (id) {
      const organizationClient = moduleClientFactory.createOrganizationClient(true);
      const response = await organizationClient.getUserById({ userId: id });
      setTeamId(response.user?.teamId);
    } else {
      setTeamId(undefined);
    }
  };

  useEffect(() => {
    if (isOpen) {
      setIsConfirmed(false);

      setUserId(currentUserId);

      if (currentUserId) {
        setTeamForUserId(currentUserId);
      }
    }
  }, [currentUserId, isOpen]);

  const handleConfirm = async () => {
    const request: AssignCaseWorkerToCompanyAppointmentsRequest = {
      appointmentIds,
      responsibleTeamId: teamId ?? '',
      responsibleCaseWorkerId: userId,
    };

    async function invokeAssign() {
      await moduleClientFactory.createCompanyAppointmentClient().assignCaseWorkerToCompanyAppointments(request);
    }

    setIsConfirmed(true);

    await invokeAssign();
    enqueueSnackbar('Alle aftaler blev tildelt sagsbehandler', { variant: 'success' });

    setIsOpen(false);
  };

  const handleTeamChange = (value: string | undefined) => {
    setTeamId(value);
    setUserId(undefined);
  };

  const handleUserChange = async (selectedUserId: string | undefined) => {
    setUserId(selectedUserId);

    await setTeamForUserId(selectedUserId ?? currentUserId);
  };

  if (!isOpen) {
    return null;
  }
  function handleClose() {
    setIsOpen(false);
  }
  return (
    <AssignCaseworkerAppointmentDialogComponent
      onConfirm={handleConfirm}
      onTeamChange={handleTeamChange}
      onUserChange={handleUserChange}
      teamId={teamId}
      userId={userId}
      open={isOpen}
      onClose={handleClose}
      isLoading={isConfirmed}
    />
  );
}
